import { render } from "./HelpView.vue?vue&type=template&id=699a0796&scoped=true&ts=true"
import script from "./HelpView.vue?vue&type=script&lang=ts"
export * from "./HelpView.vue?vue&type=script&lang=ts"

import "./HelpView.vue?vue&type=style&index=0&id=699a0796&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699a0796"]])

export default __exports__